<template>
    <div>
        <v-card>
            <v-card-text>
                <v-row>
                    <v-col cols="8">
                        <v-card-title class="titulopagina">REPORTE DE STOCK ESTANQUES ACEITE</v-card-title>
                    </v-col>
                    <v-col cols="2">
                        <date-picker v-model="fecha" placeholder ="Seleccione Fecha" @change="cargarInfo" format="DD-MM-YYYY" :default-value="fecha" valueType="YYYY-MM-DD"></date-picker>
                    </v-col>
                    <v-col cols="1">
                        <v-btn @click="generarReporte" color="green darken 1" dark> EXCEL</v-btn>
                    </v-col>
                    <v-col cols="1">
                        <v-alert class="amber accent-2 text-center" color="orange" outlined dense @click="abrirAyudas"><v-icon color="blue" large>help</v-icon></v-alert>
                    </v-col>
                </v-row>
                <modal-ayuda></modal-ayuda>
            </v-card-text>
        </v-card>

        <v-row>
            <v-col cols="7">
                <v-card>
                    <v-simple-table fixed-header width="80%">
                        <template v-slot:default>
                            <thead>
                                <tr>
                                    <th class="cabecera text-center" colspan="5">Estanques Externos</th>
                                </tr>
                                <tr>
                                    <th class="cabecera text-center">Bodega</th>
                                    <th class="cabecera text-center">Estanque</th>
                                    <th class="cabecera text-center">Ingresos</th>
                                    <th class="cabecera text-center">Salidas</th>
                                    <th class="cabecera text-center">Stock al {{fecha | formatearFecha}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="e in estanques_ext" :key="e.id">
                                <td class="text-center">{{ e.bodega }}</td>
                                <td class="text-center">{{ e.nombre }}</td>
                                <td class="text-right">{{ e.ingresos | formatear_miles }}</td>
                                <td class="text-right">{{ e.salidas | formatear_miles }}</td>
                                <td class="text-right">{{ e.stock | formatear_miles }}</td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                </v-card>
            </v-col>
            <v-col cols="5">
                <v-card>
                    <v-simple-table fixed-header width="80%">
                        <template v-slot:default>
                            <thead>
                                <tr>
                                    <th class="cabecera text-center" colspan="2">Estanques Internos</th>
                                </tr>
                                <tr>
                                    <th class="cabecera text-center">Estanque</th>
                                    <th class="cabecera text-center">Stock al {{fecha | formatearFecha}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="e in estanques" :key="e.id">
                                <td class="text-center">{{ e.codigo }}</td>
                                <td class="text-right">{{ e.stock | formatear_miles }}</td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex';
//datepicker vue2
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';
import ModalAyudas from '@/components/shared/ModalAyudas.vue';
export default {
    data:()=>({
        estanques :[],
        estanques_ext :[],
        fecha:''
    }),
    mounted() {
        this.fecha = this.moment().format('YYYY-MM-DD');
        this.cargarInfo()
    },
    methods: {
        abrirAyudas(){
            let jiji = [
                        {   titulo:`Ayuda de Reporte de Stock de Aceite en Planta`,    tipo:`titulo`},
                        {   tipo:`label`,   texto:`En esta pantalla se muestra el stock por sistema de los estanques externos y de planta. Se puede buscar el stock existente a una fecha determinada`},
                    ]
            
            Event.$emit('mostrar_alert', jiji);
        },
        async cargarEstanques(){
            //this.mostrarLoading('Cargando Stock de Estanques...');
            this.mostrarLoading({titulo:'Cargando Stock de Estanques...',color:'green'})

            let url = `${this.base_url}estanque_aceites`;
            await this.axios.get(url,this.headers).then((res)=>{
                this.estanques = res.data.data;
                console.log('estanques',this.estanques);
                this.ocultarLoading();
            }).catch((error)=>{
                console.log('error',error);
                this.ocultarLoading();
            });
        },
        async cargarEstanquesExternos(){
            this.mostrarLoading({titulo:'Cargando estanques externos...',color:'green'})
            let url = `${this.base_url}estanques_externos/0/${this.fecha}`;
            await this.axios.get(url,this.headers).then(async (res)=>{
                this.estanques_ext = res.data.data;
                this.ocultarLoading();
            }).catch((error)=>{
                console.log('error',error);
                this.errorMessage(error, "Error al cargar estanques externos ");
            });
        },
        async cargarInfo(){
            //this.mostrarLoading('Cargando Stock de Estanques...');
            this.mostrarLoading({titulo:'Cargando Stock de Estanques...',color:'green'})

            let url = `${this.base_url}estanques/stock/${this.fecha}`;
            await this.axios.get(url,this.headers).then((res)=>{
                console.log('respuesta consulta',res.data.data);
                this.estanques = res.data.data;
                this.ocultarLoading();
            }).catch((error)=>{
                console.log('error',error);
                this.ocultarLoading();
            });
            this.cargarEstanquesExternos();
        },
        async generarReporte() {
            this.mostrarLoading({titulo:'Cargando Stock de Estanques...',color:'green'})
            if(!this.fecha) this.fecha = this.moment().format('YYYY-MM-DD');

            const url = `${this.base_url}estanques/reporte_stock_excel/${this.fecha}`;
            await this.axios.get(url,this.headers).then(res => {
                window.location.href = this.download_url + res.data.data;
                this.ocultarLoading();
            }).catch(error => {
                console.log('error', error);
                this.ocultarLoading();
            });
        },
        ...mapMutations(['mostrarLoading','ocultarLoading'])
    },
    computed: {
        ...mapState(['base_url','headers', 'download_url'])
    },
    components:{
        DatePicker,
        'modal-ayuda':ModalAyudas
    }
}
</script>